import { TFunction } from '@lyearn/i18n';
import { PropertiesToDuplicateEnum } from '@/types/schema';

import { ProjectDuplicationFormPropertiesType } from './components/Editor/config';

export const getTaskPropertiesToDuplicateOptions = (t: TFunction) => [
  {
    label: t('Task:DuplicationProperties.DueDate'),
    value: PropertiesToDuplicateEnum.DueDate,
  },
  {
    label: t('Task:DuplicationProperties.Assignees'),
    value: PropertiesToDuplicateEnum.Assignees,
  },
  {
    label: t('Task:DuplicationProperties.Priority'),
    value: PropertiesToDuplicateEnum.Priority,
  },
  {
    label: t('Task:DuplicationProperties.Tags'),
    value: PropertiesToDuplicateEnum.Tags,
  },
  {
    label: t('Task:DuplicationProperties.Status'),
    value: PropertiesToDuplicateEnum.Status,
  },
  {
    label: t('Task:DuplicationProperties.Stages'),
    value: PropertiesToDuplicateEnum.Stages,
  },
  {
    label: t('Task:DuplicationProperties.Subtasks'),
    value: PropertiesToDuplicateEnum.SubTasks,
  },
];

export enum ProjectPropertiesToDuplicateEnum {
  ProjectSettings = 'ProjectSettings',
  ProjectMembers = 'ProjectMembers',
}

export const getProjectPropertiesToDuplicateOptions = (t: TFunction) => [
  {
    label: t('Task:DuplicateProject.ProjectSettings'),
    value: ProjectPropertiesToDuplicateEnum.ProjectSettings,
  },
  {
    label: t('Task:DuplicateProject.ProjectMembers'),
    value: ProjectPropertiesToDuplicateEnum.ProjectMembers,
  },
];

const ProjectSettingsProperties = [
  PropertiesToDuplicateEnum.DueDate,
  PropertiesToDuplicateEnum.Assignees,
  PropertiesToDuplicateEnum.Status,
  PropertiesToDuplicateEnum.Stages,
  PropertiesToDuplicateEnum.VisibilitySettings,
  PropertiesToDuplicateEnum.Client,
];

export const adaptPropertiesForMutation = (properties: ProjectDuplicationFormPropertiesType) => {
  const { projectPropertiesToDuplicate, actionItemPropertiesToDuplicate } = properties;
  const propertiesToDuplicate = [];

  if (actionItemPropertiesToDuplicate.length) {
    propertiesToDuplicate.push(PropertiesToDuplicateEnum.Task);
  }

  if (projectPropertiesToDuplicate.includes(ProjectPropertiesToDuplicateEnum.ProjectSettings)) {
    propertiesToDuplicate.push(...ProjectSettingsProperties);
  } else if (actionItemPropertiesToDuplicate.includes(PropertiesToDuplicateEnum.Stages)) {
    // if project settings is not selected but stages is selected in action items
    propertiesToDuplicate.push(PropertiesToDuplicateEnum.Stages);
  }

  // TODO. (After we implement Project Members feature)
  // if (projectPropertiesToDuplicate.includes(ProjectPropertiesToDuplicateEnum.ProjectMembers)) {
  // Push whatever property is required to duplicate project members
  // }

  // always duplicate Media
  propertiesToDuplicate.push(PropertiesToDuplicateEnum.Media);

  return {
    propertiesToDuplicate,
    actionItemPropertiesToDuplicate,
  };
};
